import React from "react";
import {
  Footer,
  Homepage,
  Services,
  JobApplication,
  PricingOrder,
} from "./container";
import NotFound from "./container/NotFound/NotFound";
import CV from "./container/CV/CV";
import { Navbar } from "./components";
import CommandPalette from "./components/CommandPalette/CommandPalette";
import { BackToTop, CursorFollower, MagneticButtons, PageTransition, RouteEffects } from "./components/Effects/Effects";
import { ThemeProvider } from "./context/ThemeContext";

import "./App.scss";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

const App = () => {
  return (
    <ThemeProvider>
      <div className="app">
        <BrowserRouter>
          <RouteEffects />
          <Navbar />
          <CommandPalette />
          <PageTransition>
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/services" element={<Services />} />
              <Route path="/cv" element={<CV />} />
              <Route path="/resume" element={<Navigate to="/cv" replace />} />
              <Route path="/portfolio" element={<Navigate to="/" replace />} />
              <Route path="/job-application" element={<JobApplication />} />
              <Route path="/pricing-order" element={<PricingOrder />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </PageTransition>
          <Footer />
          <BackToTop />
          <CursorFollower />
          <MagneticButtons />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
};

export default App;
